(() => {
  const LS_KEY = "lazza_zip_last";
  const CONTACT_EMAIL = "contact@lazza-traiteur.fr";

  function isZip(v) {
    return /^\d{5}$/.test((v || "").trim());
  }

  function applyMsgStyle(msgEl) {
    if (!msgEl) return;
    msgEl.style.opacity = "0.85";
    msgEl.style.fontWeight = "500";
  }

  function setMsg(msgEl, text) {
    if (!msgEl) return;
    msgEl.textContent = text || "";
    applyMsgStyle(msgEl);
  }

  function setMsgHtml(msgEl, html) {
    if (!msgEl) return;
    msgEl.innerHTML = html || "";
    applyMsgStyle(msgEl);
  }

  function setKoCtaToMailto(koCta, zipValue) {
    if (!koCta) return;

    // Optionnel: pré-remplissage du mail (zip dans le corps)
    const subject = encodeURIComponent("Demande de livraison hors zone – Lazza-Traiteur");
    const body = encodeURIComponent(
      `Bonjour,\n\nMon code postal est : ${zipValue || ""}\nEntreprise : \nDate souhaitée : \nNombre de personnes : \nCommentaire : \n\nMerci,`
    );
    const mailto = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;

    const tag = (koCta.tagName || "").toLowerCase();
    if (tag === "a") {
      koCta.setAttribute("href", mailto);
      // Si jamais il y avait un target/rel bizarres, on peut les laisser
    } else {
      // Bouton ou autre élément cliquable
      koCta.onclick = (e) => {
        e.preventDefault?.();
        window.location.href = mailto;
      };
    }
  }

  function loadZipsFromWindow() {
    const arr = Array.isArray(window.LAZZA_DELIVERY_ZIPS) ? window.LAZZA_DELIVERY_ZIPS : [];
    return new Set(arr.map(s => String(s).trim()).filter(Boolean));
  }

  function bind(zips) {
    const input = document.querySelector("[data-lazza-zip-input]");
    const btn = document.querySelector("[data-lazza-zip-btn]");
    const msg = document.querySelector("[data-lazza-zip-msg]");
    const okCta = document.querySelector("[data-lazza-zip-cta-ok]");
    const koCta = document.querySelector("[data-lazza-zip-cta-ko]");

    if (!input || !btn || !msg) return false;

    // Préremplissage
    try {
      const last = localStorage.getItem(LS_KEY);
      if (last && !input.value) input.value = last;
    } catch {}

    // Reset CTAs au chargement
    if (okCta) okCta.style.display = "none";
    if (koCta) koCta.style.display = "none";
    setMsg(msg, ""); // message discret vide au départ

    function evaluate() {
      const v = (input.value || "").trim();

      if (okCta) okCta.style.display = "none";
      if (koCta) koCta.style.display = "none";

      if (!isZip(v)) {
        setMsg(msg, "Merci d’indiquer un code postal à 5 chiffres.");
        return;
      }

      try { localStorage.setItem(LS_KEY, v); } catch {}

      // Si la liste n'est pas chargée (ou vide), on affiche un message explicite
      if (!zips || zips.size === 0) {
        setMsg(msg, "Vérification indisponible pour le moment.");
        return;
      }

      if (zips.has(v)) {
        setMsg(msg, "✅ Zone desservie : vous pouvez commander.");
        if (okCta) okCta.style.display = "";
      } else {
        // Message avec lien mailto cliquable
        const mailtoSimple = `mailto:${CONTACT_EMAIL}`;
        setMsgHtml(
          msg,
          `❌ Hors zone pour l’instant. <a href="${mailtoSimple}">Contactez-nous</a> pour une solution sur mesure.`
        );

        // CTA "Demander une solution →" : on le force aussi en mailto pour éviter la 404
        setKoCtaToMailto(koCta, v);
        if (koCta) koCta.style.display = "";
      }
    }

    // Évite doubles bind si le header se re-render
    if (!btn.dataset.lazzaBound) {
      btn.dataset.lazzaBound = "1";
      btn.addEventListener("click", evaluate);
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") { e.preventDefault(); evaluate(); }
      });
    }

    return true;
  }

  function initWithRetry() {
    const zips = loadZipsFromWindow();

    const start = Date.now();
    const timer = setInterval(() => {
      if (bind(zips)) clearInterval(timer);
      if (Date.now() - start > 4000) clearInterval(timer);
    }, 150);
  }

  document.addEventListener("DOMContentLoaded", initWithRetry);
})();